module.exports = __webpack_public_path__ + "static/media/SingleCoupon_detailContent.2dcfb76e.png";